var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map",attrs:{"id":"map"}},[_c('div',{staticClass:"part1",attrs:{"id":"p1"}},[(_vm.img1)?_c('img',{attrs:{"src":_vm.img1}}):_vm._e()]),_c('div',{staticClass:"part2",attrs:{"id":"p2"}},[(_vm.img2)?_c('img',{attrs:{"src":_vm.img2}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }